// extracted by mini-css-extract-plugin
module.exports = {"social":"shareblock_social__BzgeE"};